document.addEventListener(
  'DOMContentLoaded',
  () => {
    setInterval(() => {
      const marquees = Array.from(document.querySelectorAll('.marquee-title'))
      const active = marquees.find((marquee) =>
        marquee.classList.contains('active')
      )
      const idx = marquees.indexOf(active)
      const next = idx === marquees.length - 1 ? 0 : idx + 1
      marquees[next].classList.add('active')
      active.classList.add('out')
      active.classList.remove('active')

      setTimeout(() => {
        active.classList.remove('out')
      }, 1000);
    }, 3500)
  },
  false
)
